import { all } from 'redux-saga/effects';

import addressBookSaga from './address-book-saga';

export default function* rootSaga() {
  yield all([addressBookSaga()]);
}
